import React, { useState, useRef, useEffect } from "react";

const CategoryScrollFilter = ({ firstCategoryList, filterSelected, sendFilterDataFromChild }) => {
    const [selectedMasterCategories, setSelectedMasterCategories] = useState([]);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(true);
    const scrollContainerRef = useRef(null);

    useEffect(() => {
        if (filterSelected) {
            const mastercategoryIds = filterSelected?.masterCategoryIdArray
                ? String(filterSelected.masterCategoryIdArray).split(',').map(Number)
                : [];

            setSelectedMasterCategories(mastercategoryIds);
        }
    }, [filterSelected]);

    useEffect(() => {
        const container = scrollContainerRef.current;
        if (container) container.addEventListener("scroll", handleScroll);
        return () => container?.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        handleScroll();
    }, [firstCategoryList]);

    const handleScroll = () => {
        const container = scrollContainerRef.current;
        if (container) {
            const isAtStart = container.scrollLeft === 0;
            const isAtEnd = Math.ceil(container.scrollLeft + container.clientWidth) >= container.scrollWidth;
            setShowLeftArrow(!isAtStart);
            setShowRightArrow(!isAtEnd);
        }
    };
    const handleScrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: 200, behavior: "smooth" });
            setTimeout(handleScroll, 300);
        }
    };
    const handleScrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: -200, behavior: "smooth" });
            setTimeout(handleScroll, 300);
        }
    };
    
    const handleFirstClick = async (event, value) => {
        const { mastercategoryid: checkedId } = value;
        const isChecked = event.target.checked;
    
        const updatedMasterCategoryIds = isChecked
            ? [...selectedMasterCategories, checkedId]
            : selectedMasterCategories.filter(id => id !== checkedId);
    
        setSelectedMasterCategories(updatedMasterCategoryIds);
        sendFilterDataFromChild({
            type: 'product',
            masterCategoryIds: updatedMasterCategoryIds,
        });
    };
   
    const handleCategoryClearFilter = async () => {
        // blank set value
        setSelectedMasterCategories([]);
        sendFilterDataFromChild({type: 'product', masterCategoryIds: []});
    };

    return (
        <div className="space-y-1 sm:space-y-2">
            {/* Categories */}
            <div className="flex items-center justify-start">
                {(selectedMasterCategories.length > 0) ?
                    <img onClick={handleCategoryClearFilter} className="cursor-pointer" src={`../../../../assets/icons/table/red-filter.svg`} alt="clear filters" />
                    :
                    <img src={`../../../../assets/icons/table/blue-filter.svg`} alt="filters" />
                }

                {showLeftArrow ?
                        <img onClick={handleScrollLeft} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/left-arrow-active.svg" alt="left" />
                    :
                        <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/left-arrow-disable.svg" alt="left" />
                }

                <div ref={scrollContainerRef} className="flex overflow-x-scroll no-scrollbar gap-1 sm:gap-2 max-w-full text-[10px] sm:text-xs">
                    {firstCategoryList.map((category, index) => {
                        const isChecked = selectedMasterCategories.includes(category.mastercategoryid);
                        return (
                            <label
                                key={'cat' + index}
                                className={`flex items-center gap-1 px-2 sm:px-3 py-1 rounded-full cursor-pointer transition-all duration-200 border border-black-100 ${
                                isChecked ? "bg-blue-light" : "bg-white"
                                }`}
                            >
                                <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={(event) => handleFirstClick(event, category)}
                                    className="hidden"
                                />
                                <span className="flex w-max font-semibold">{category.mastercategoryname}</span>
                            </label>
                        );
                    })}
                </div>

                {showRightArrow ?
                        <img onClick={handleScrollRight} className="px-2 py-1 z-40 cursor-pointer" src="../../../../assets/icons/table/right-arrow-active.svg" alt="right" />
                    :
                        <img className="px-2 py-1 z-40 cursor-not-allowed" src="../../../../assets/icons/table/right-arrow-disable.svg" alt="right" />
                }
            </div>
        </div>
    );
};

export default CategoryScrollFilter;
